import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=3adc1b60&scoped=true&"
import script from "./CardInfo.vue?vue&type=script&lang=ts&"
export * from "./CardInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc1b60",
  null
  
)

export default component.exports